module.exports = __webpack_public_path__ + "static/img/91BM-057-YuanyuanAn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-057-YuanyuanAn.jpg
// module id = k6q9
// module chunks = 0